export const environment = {
  name: 'dev',
  production: false,
  instrumentationKey: "",

  // Notification Agent backend API
  apiBaseUrl: 'http://localhost:8000'
};
